import { Dispatch, SetStateAction } from 'react';

import { clsx } from 'clsx';
import { useFormikContext } from 'formik';

import ChevronLeft from '../../../../components/svg/ChevronLeft.svg';
import { CrossSellFormValues } from '../../utils/CrossSellCard.types';
import { CrossSellSteps, decrementStep } from '../../utils/stepHandler';

export const HeaderControls = ({
  step,
  setStep,
}: {
  step: CrossSellSteps;
  setStep: Dispatch<SetStateAction<CrossSellSteps>>;
}) => {
  const { resetForm, setFieldValue, isSubmitting } =
    useFormikContext<CrossSellFormValues>();
  return (
    <div className="mb-l grid grid-cols-2">
      {(step === 'APPLICANT_INFORMATION' || step === 'PRIVACY_POLICY') && (
        <button
          className={clsx(
            'col-start-1 w-fit cursor-pointer border-0 bg-transparent text-s font-bold',
            {
              'text-structure-60': isSubmitting,
              'text-primary-40': !isSubmitting,
            },
          )}
          disabled={isSubmitting}
          onClick={async () => {
            if (step === 'PRIVACY_POLICY') {
              await setFieldValue('policyAgreed', false);
            }
            setStep((currStep) => decrementStep(currStep));
          }}
        >
          <div className="flex items-center">
            <img src={ChevronLeft} alt="" />
            Back
          </div>
        </button>
      )}

      {step !== 'INTRODUCTION' && (
        <button
          className={clsx(
            'col-start-2 w-fit cursor-pointer justify-self-end border-0 bg-transparent text-s font-bold',
            {
              'text-structure-60': isSubmitting,
              'text-primary-40': !isSubmitting,
            },
          )}
          disabled={isSubmitting}
          onClick={() => {
            resetForm();
            setStep('INTRODUCTION');
          }}
        >
          Cancel
        </button>
      )}
    </div>
  );
};
